import { DEFAULT_LOCALE, type LocaleCode } from '~/constants/i18n';
import { normalizeLocale } from '~/utils/i18n/locale';

export type LocalizedField = string | Partial<Record<LocaleCode, string | null>> | null | undefined;

const usable = (value: unknown): string | null => (typeof value === 'string' && value.trim() ? value : null);

/**
 * Picks the `locale` variant of a per-locale payload field (`title.ru`, `title.ar` …),
 * falling back to English, then to `fallback`. Plain strings pass through unchanged.
 */
export const pickLocalized = (field: LocalizedField, locale: string | null | undefined, fallback = ''): string => {
  if (typeof field === 'string') return usable(field) ?? fallback;
  if (!field) return fallback;
  const code = normalizeLocale(locale);
  return (code && usable(field[code])) || usable(field[DEFAULT_LOCALE]) || fallback;
};
